// extracted by mini-css-extract-plugin
module.exports = {"primaryActions":"PrimaryActions_primaryActions__2XT8C","noGap":"PrimaryActions_noGap__6JLGt"};